/**
* @Author: Daniel Rhees <Daniel>
* @Date:   2017-01-10T12:01:05-08:00
* @Email:  daniel@reflexmedia.com
* @Last modified by:   Daniel
* @Last modified time: 2017-03-26T19:33:54-07:00
*/

import React, { Component } from 'react';
import glamorous from 'glamorous';
import { spacing } from '../../../style';
import _ from 'lodash';
import Gallery from '../../common/Gallery';

const PhotoList = glamorous.div({
  ...spacing.MARGIN_RIGHT_SM_NEG,
});

class Photos extends Component {
  render() {
    const {
      photos,
      openLightbox
    } = this.props;

    return (
      <PhotoList>
        <Gallery images={photos} openLightbox={openLightbox} />
      </PhotoList>
    )}
};

export default Photos;



// WEBPACK FOOTER //
// ./src/components/pages/Profile/Photos.jsx